import { getAuthHeaders } from "@/api/auth"
import { BASE_URL } from "@/constants/util"
import axios from "@/api/axiosAuthRequired.js"
import { isEmpty } from "lodash"

export const fetchUser = async () => {
  // TODO:
  //  Clean up check on headers for all endpoints requiring an auth token, perhaps in axiosAuthRequired.js. Also make
  //  an extension of axios for optional auth endpoints (to also implement the interceptor for refreshing tokens
  const authHeaders = getAuthHeaders()
  if (isEmpty(authHeaders)) {
    return null
  }

  try {
    const url = `${BASE_URL}user/account`
    const config = {
      headers: authHeaders,
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const updateCommunicationMethods = async body => {
  try {
    const url = `${BASE_URL}user/account/settings/communication-methods`
    const config = {
      headers: getAuthHeaders(),
    }
    await axios.put(url, body, config)
    return { success: true }
  } catch (error) {
    console.error(error)
    return {
      success: false,
      message: error.response.data,
    }
  }
}

export const fetchUserGameProfile = async (gameId) => {
  try {
    const url = `${BASE_URL}user/account/games/user-game-generics?game_id=${gameId}`
    const config = {
      headers: getAuthHeaders(),
    }
    const response = await axios.get(url, config)
    return response.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const updateUserGameProfile = async (gameId, profileData) => {
  try {
    const url = `${BASE_URL}user/account/games/user-game-generics`
    const body = Object.assign({
      game_id: gameId,
    }, profileData)
    const config = {
      headers: getAuthHeaders(),
    }
    await axios.put(url, body, config)
    return { success: true }
  } catch (error) {
    console.error(error)
    return {
      success: false,
      message: error.response.data?.message,
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/user.apis.js